import ActivitiesKanbanCard from 'app/main/modules/activities/ActivitiesKanbanCard';
import OpportunitiesKanbanCard from 'app/main/modules/opportunities/OpportunitiesKanbanCard';

const kanbanCards = {
	activities: ActivitiesKanbanCard,
	opportunities: OpportunitiesKanbanCard
};

export default kanbanCards;
